"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _default = _propTypes.default.shape({
  duplicateVideo: _propTypes.default.func.isRequired,
  deleteVideo: _propTypes.default.func.isRequired,
  fetchDraftVideos: _propTypes.default.func.isRequired,
  fetchPublishVideos: _propTypes.default.func.isRequired
});

exports.default = _default;